export interface AppRegistrationDTO {
    id: number;
    userId: number;
    description: string;
    clientId: string;
    clientSecret: string;
    providerId: number;
    provider: string;
    dueDateClientSecret: Date;
}

export interface AppRegistrationWriteDTO {
    userId: number;
    description: string;
    clientId: string;
    clientSecret: string;
    providerId: number;
    dueDateClientSecret: Date;
}

export function createAppRegistration( userId: number, description: string, clientId: string, clientSecret: string, providerId: number, dueDateClientSecret: Date
) {
    return { userId: userId, description: description, clientId: clientId, clientSecret: clientSecret, providerId: providerId, dueDateClientSecret: dueDateClientSecret }
}